import { useQuery } from '@tanstack/react-query';
import { commonQueryOptions } from '../utils';
import { HiverCustomFieldNewAuth } from '../../../common';
import { QUERY_KEYS } from '../constants';

const customFieldListApi = (smId) => HiverCustomFieldNewAuth({
  url: `/api/v1/config/custom-fields?inbox_id=${smId}`,
  method: 'GET',
});

export const useCustomFieldListApi = (smId, refetchOnMount = false) => {
  return useQuery({
    ...commonQueryOptions,
    refetchOnMount: refetchOnMount,
    queryKey: [QUERY_KEYS.customFieldList, smId],
    queryFn: () => customFieldListApi(smId),
  });
};
